import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

const TUTORIALS = [
  { title: 'Tutorial 1: Crear empresa por primera vez', url: 'https://www.youtube.com/watch?v=15h1XEdlAJ8' },
  { title: 'Tutorial 2: Crear mi primer servicio en la pagina', url: 'https://www.youtube.com/watch?v=NowUdmePjSM' },
  { title: 'Tutorial 3: Crear mi primer producto para la venta', url: 'https://www.youtube.com/watch?v=83DIL9hbgIA' },
  { title: 'Tutorial 4: Aprender a manejar tickets de soporte de mis clientes', url: 'https://www.youtube.com/watch?v=gkqBKDiHEMY' },
  { title: 'Tutorial 5: Crear una noticia en mi pagina web propia', url: 'https://www.youtube.com/watch?v=kSezpXvnG34' },
  { title: 'Tutorial 6: Integración con pasarela de pagos', url: 'https://www.youtube.com/watch?v=MoERQKCgSlU' },
  { title: 'Tutorial 7: como configurar citas multiples y crear trabajadores en mi empresa', url: 'https://www.youtube.com/watch?v=fJuDjxgfuxY' },
];

function Tutoriales() {
  const isMobile = useIsMobile();

  return (
    <main style={{ padding: '3rem 1.5rem', maxWidth: isMobile ? '860px' : '1180px', margin: '0 auto' }}>
      <div style={{
        backgroundColor: theme.colors.background,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: 'clamp(1.5rem, 5vw, 2rem) clamp(1.25rem, 5vw, 2.5rem)',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
        textAlign: 'center',
      }}>
        <h1 style={{ color: theme.colors.primary, fontSize: '1.6rem', marginBottom: '0.5rem' }}>
          Tutoriales
        </h1>
        <div style={{
          width: '40px',
          height: '3px',
          backgroundColor: theme.colors.primary,
          margin: '0 auto 1.8rem',
          borderRadius: '2px',
        }} />
        <p style={{ color: theme.colors.textMuted, fontSize: '0.95rem', marginBottom: '2rem' }}>
          Aprende a usar la plataforma paso a paso con nuestros videos tutoriales.
        </p>

        {TUTORIALS.map((t, i) => (
          <div key={i} style={{ marginBottom: '1.8rem' }}>
            <p style={{ color: theme.colors.text, fontSize: '0.95rem', marginBottom: '0.7rem' }}>
              {t.title}
            </p>
            <a
              href={t.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                backgroundColor: theme.colors.primary,
                color: theme.colors.background,
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem',
                padding: '0.6rem 1.4rem',
                borderRadius: '8px',
              }}
            >
              ▶ Ver tutorial
            </a>
          </div>
        ))}
      </div>
    </main>
  );
}

export default Tutoriales;
